import React from 'react';
import PropTypes from 'prop-types';
import { Utils, translate } from 'versafleet-core';

const DeleteSuccessMessage = props => (
  <div className="vf-task__delete-success-message">
    <div className="vf-task__delete-success-message__icon">
      <i className="versa-delete" />
    </div>
    {
      Utils.TranslationHelper.replaceTag(props.strings.page.deleteSuccess, {
        count: props.count,
      })
    }
  </div>
);

DeleteSuccessMessage.displayName = 'Delete Success Message';

DeleteSuccessMessage.propTypes = {
  count: PropTypes.number.isRequired,
  strings: PropTypes.shape({
    page: PropTypes.shape({
      deleteSuccess: PropTypes.string,
    }),
  }).isRequired,
};

export default translate('Task')(DeleteSuccessMessage);
